import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import PackageInfo from './info';
import PreviewDevice from '@/components/PreviewDevice';
import PreviewAction from '@/views/creative/components/preview-action.vue';
import ReloadBtn from './reloadBtn';
import { language } from '@/common/storage';
import DcoPreviewList from './dcoPreviewList.vue';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { addQueryString } from '@com/utils/url';
import { mindworksInteractiveAdsUrl } from '@pt/config/host';
import { mapState } from 'vuex';

export default {
  props: {
    config: {
      type: Object,
      default: function _default() {}
    },
    previewUrl: {
      type: String,
      default: ''
    },
    isDcoPreview: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    PackageInfo: PackageInfo,
    PreviewAction: PreviewAction,
    PreviewDevice: PreviewDevice,
    ReloadBtn: ReloadBtn,
    DcoPreviewList: DcoPreviewList
  },
  data: function data() {
    return {
      condition: {
        orientation: 1,
        deviceType: 3
      },
      preview_url: '',
      loading: false,
      list: [],
      filterplatform: 0,
      filterlanguage: 0
    };
  },

  computed: _extends({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.info;
    }
  }), {
    platformOptions: function platformOptions() {
      var opionts = [];
      if (this.data.length) {
        this.data.forEach(function (item) {
          if (opionts.length === 0 || !opionts.some(function (option) {
            return option.label === item.platform;
          })) {
            opionts.push({
              label: item.platform,
              value: opionts.length
            });
          }
        });
      }
      return opionts;
    },
    languageOptions: function languageOptions() {
      var opionts = [];
      if (this.data.length) {
        this.data.forEach(function (item) {
          if (opionts.length === 0 || !opionts.some(function (option) {
            return option.label === item.language;
          })) {
            opionts.push({
              label: item.language,
              value: opionts.length
            });
          }
        });
      }
      return opionts;
    },
    innerList: function innerList() {
      var _this = this;

      var list = this.data;
      if (this.filterplatform !== '') {
        list = list.filter(function (item) {
          return item.platform === useValueExchangeLabel(_this.filterplatform, _this.platformOptions);
        });
      }
      if (this.filterlanguage !== '') {
        list = list.filter(function (item) {
          return item.language === useValueExchangeLabel(_this.filterlanguage, _this.languageOptions);
        });
      }
      return list;
    }
  }),
  methods: {
    // 重新加载
    handleReload: function handleReload() {
      var _this2 = this;

      this.preview_url = '';
      this.$nextTick(function () {
        _this2.preview_url = _this2.cookPreviewUrl(_this2.previewUrl);
      });
    },

    // 添加PL的loading
    cookPreviewUrl: function cookPreviewUrl(url) {
      if (!url) return '';
      var previewUrl = addQueryString(url, {
        loading: 1,
        lang: language.get()
      });
      return addQueryString(mindworksInteractiveAdsUrl, {
        url: previewUrl,
        ptloading: 1, // 是否使用pt loading
        mw_test: process.env.NODE_ENV === 'production' ? 0 : 1,
        track_data: _JSON$stringify({
          pid: this.config && (this.config.template_id || this.config.id),
          uid: this.userInfo.id,
          sct: 'pt_project_custom',
          env: process.env.NODE_ENV === 'production' ? 'p' : 't',
          cc: this.userInfo.cc || -1
        })
      });
    },

    // dco切换逻辑
    changePreviewUrl: function changePreviewUrl(_ref) {
      var group = _ref.group;

      this.$emit('changePreview', { group: group });
    }
  },
  watch: {
    // 弹窗一出现就loading
    'config.visible': function configVisible(val) {
      this.preview_url = '';
      if (val) {
        this.loading = true;
        // 防止多次预览同一个url而不结束loading
        if (this.previewUrl) {
          this.preview_url = this.cookPreviewUrl(this.previewUrl);
        }
      }
    },

    // 传入的url
    previewUrl: function previewUrl(url) {
      if (url) {
        this.preview_url = this.cookPreviewUrl(url);
      }
    },

    // 实际预览的url
    preview_url: function preview_url(url) {
      if (url) {
        this.loading = false;
      }
    },

    // 切换语言的时候，触发重新加载
    filterlanguage: function filterlanguage() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.dcoList.triggerClick();
      });
    }
  }
};